import React from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import './placesSearch.scss'
 
function PlacesSearch(props) {

    const getValue = () => {
        const defaultPlace = {
            address: '',
            lat: null,
            lng: null
        }
        if (props.getValues){
            // console.log('trying to get the value')
            // console.log(props.getValues(props.name))
            return props.getValues(props.name) ?? defaultPlace
        }
        return defaultPlace
        // if (options) {
        //   return options.find(option => option.value === getValues(name));
        // } else {
        //   return isMulti ? [] : ("");
        // }
    };
//   constructor(props) {
//     super(props);
//     this.state = { address: '' };
//   }

    // const { place } = props;
    // const {address, lat, lng } = props?.place

    const [place, setPlace] = React.useState(getValue())
    const [address, setAddress] = React.useState(getValue()?.address ?? '')
 
    const handleChange = (address) => {
        // setPlace({
        //     ...place,
        //     address: address
        // })
        // this.setState({ 
        //     ...this.state,
        //     address
        // });
    };

    // export function getLatLng(results: google.maps.GeocoderResult): Promise<google.maps.LatLngLiteral>;

    const getCityState = (results) => {
      if (!results.address_components) {
        return {}
      }
      var constructedCityState = ""
      results.address_components.forEach(comp => {
        // if ((comp.types ?? []).includes("neighborhood")) {
        if ((comp.types ?? []).includes("locality")) {
          constructedCityState = constructedCityState.concat(comp.long_name + ", ")
        }
        if ((comp.types ?? []).includes("administrative_area_level_1")) {
          constructedCityState = constructedCityState.concat(comp.short_name)
        }
      })

      return {
        cityState: constructedCityState
      }
    }
 
    const handleSelect = (address) => {
        setAddress(address)
        geocodeByAddress(address)
        .then(results => {
          return Promise.all([getLatLng(results[0]), Promise.resolve(getCityState(results[0]))])
        })
        .then(([latLng, cityState]) => {
            const newPlace = {
                address: address,
                contentLink: `https://www.google.com/maps/place/${latLng.lat},${latLng.lng}`,
                ...latLng,
                ...cityState
            }
            setPlace(newPlace)
            if (props.onChange) {
                props.onChange(newPlace)
            }
            if (props.setValue && props.name) {
                props.setValue(props.name, newPlace)
            }
        })
        .catch(error => console.error('Error', error));
    };

    
 
  
    return (
        <>
        <label>Address</label>
        <PlacesAutocomplete
            value={address}
            onChange={setAddress}
            onSelect={handleSelect}
        >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <div className="input-group">
                <input
                {...getInputProps({
                    placeholder: 'Search for a place...',
                    className: 'location-search-input',
                })}
                className="form-control"
                />
            </div>
            <div className="position-absolute autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active p-2'
                  : 'suggestion-item p-2';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div key={index}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      </>
    );
}

export default PlacesSearch